import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { SearchPaymentModel } from "../../models/business/search-payment.model";
import { HttpService } from "../common/http-service";


const PAYMENT_API = environment.apiURL + '/api/adm/Payment/';
@Injectable({
    providedIn: 'root'
})

export class PaymentService {

    //#region Fields

    //#endregion

    //#region Constructor

    constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
    }
    //#endregion

    //#region Public Methods
    getpayments(model: SearchPaymentModel) {
        var url = PAYMENT_API + "getpayments";
        return this._httpService.httpPost(url, model)
            .pipe(map(resposne => {
                return resposne;
            }));
    }
    //#endregion
}